import React from 'react'
import './Loading.css'
function Loading() {
  return (
    <div className='loading'>
            <div className="after"></div>
    </div>
  )
}

export default Loading